import React from 'react';
import clsx from 'clsx';
import _ from 'lodash';
import { Icons, Box, IconButton } from "@curves/ui-base";
import { useInBodyContext } from '@icoach/inbody/components/InBodyContext';

const InBodyXFactorBox = React.forwardRef((props, ref) => {
    const { sourceData = [], measureID } = props;
    const { peopleID, dialogRef, refresh } = useInBodyContext();

    const handleOnClick = () => {
        dialogRef.current.openInBodyXFactorDialog({ list: sourceData, measureID, memberID: peopleID }, refresh);
    };
    const isEmptyData = _.isEmpty(sourceData);

    return (
        <Box onClick={handleOnClick} className={clsx('cursor-pointer', { 'text-left': !isEmptyData })}>
            {isEmptyData ? (
                <IconButton>
                    <Icons.Edit />
                </IconButton>
            ) : (
                <ol className="list-default">
                    {sourceData[0] && <li>{sourceData[0].taskTitle}</li>}
                    {sourceData[1] && <li>{sourceData[1].taskTitle}</li>}
                </ol>
            )}
        </Box>
    );
});

export default InBodyXFactorBox;
